import { cn } from "cn";
import type { FC } from "react";
import React, { useState } from "react";

import { Button } from "@react/ui-primitives/button";

import { ErrorViewDemo } from "./demos/ErrorViewDemo.tsx";
import { LoadingViewDemo } from "./demos/LoadingViewDemo.tsx";
import { MediaUploadDemo } from "./demos/media-upload-demo/MediaUploadDemo.tsx";
import { NotFoundViewDemo } from "./demos/NotFoundViewDemo.tsx";

const DEMOS = [
  { Component: ErrorViewDemo, label: "ErrorView" },
  { Component: LoadingViewDemo, label: "LoadingView" },
  { Component: NotFoundViewDemo, label: "NotFoundView" },
  { Component: MediaUploadDemo, label: "Media upload" },
] as const;

export const PlaygroundView: FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeDemo = DEMOS[activeIndex];

  return (
    <div className="flex flex-1 gap-6">
      <nav className="flex w-48 flex-col gap-1">
        {DEMOS.map((demo, index) => (
          <Button
            className={cn("justify-start")}
            key={demo.label}
            onClick={() => {
              setActiveIndex(index);
            }}
            variant={index === activeIndex ? "default" : "ghost"}
          >
            {demo.label}
          </Button>
        ))}
      </nav>
      <div className="flex-1 rounded-lg border p-6">
        {activeDemo && <activeDemo.Component />}
      </div>
    </div>
  );
};
